import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import Moment from "react-moment";
import { FieldRenderProps } from "react-final-form";
import { commonsStoreContext } from "../../../model/CommonsStore";

export interface PresentationalTimeComponentProps
  extends FieldRenderProps<any> {
  customDateFormat?: string;
}

export const DateTimeRenderer = observer(
  (props: PresentationalTimeComponentProps) => {
    const { dateFormat } = useContext(commonsStoreContext).defaults;
    const { customDateFormat, input } = props;

    return (
      <>
        {input.value && (
          <Moment unix format={customDateFormat || dateFormat}>
            {input.value / 1000}
          </Moment>
        )}
      </>
    );
  }
);
